import React from "react";
import { useState, useEffect } from "react";
import "./AddTarget.scss";
import { Button } from "../../CommonUIComponents/Button/Button";
import { Stepper } from "../../Stepper/Stepper";
import { useDispatch, useSelector } from "react-redux";
import {
  addTarget,
  CancelBtn,
  ApplyBtn,
  AddTargetBtn,
  addTargetTableHeaderDataTargetYear,
  addTargetTableHeaderDataBaseYear,
  addTargetTableHeaderDataPercentageValue,
  addTargetTableHeaderTemporalType,
  addTargetTableHeaderTargetType,
  addTargetTableHeaderCustom,
  addTargetTableHeaderOrg,
  addTargetTableHeaderGeo,
  emission,
  addTargetTableHeaderTargetDesc,
  addTargetTableHeaderTargetName,
  foreStartYear,
  foreEndYear,
  applyErrorMessageTarget,
  addtargetTooltip,
} from "../../../util/constants";
import { Table } from "../../CommonUIComponents/Table/Table";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../routes/routes.constatns";
import { AddIcon } from "../../../icons";
import CustomEditComponent from "./CustomEditComponent";
import CustomChipscomponent from "../components/shared/CustomChips";
import { setSkipForecast } from "../../../store/slices/engagementSlice";
import { getTargets, setHierarchialData, setselectedUIAllFilters, setSelectedAllLevels } from "../../../store/slices/forecastSlice";
import { MotifErrorMessage } from "../../../assets/lib/motif";
import { formarDateTime } from "../../../util/dateUtil";
import { applyTarget } from "../../../store/services/forecast.service";
import {
  updateSkipForecast,
  uploadTextFile,
} from "../../../store/services/engagement.service";
import { LoadingIndicatorEmbed } from "../../CommonUIComponents/LoadingIndicator/LoadingIndicatorEmbed";
import { getLockingData } from '../../../store/slices/projectSlice';
import { setWafErrorFlag } from "../../../store/slices/projectSlice";

export function AddTarget() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const steps = useSelector((state) => state.stepper.steps);
  const engagement = useSelector((state) => state.engagement.engagement);
  const selectedRegion = useSelector(
    (state) => state.engagement.selectedRegion
  );
  const stepIndex = useSelector((state) => state.engagement.stepIndex);
  const currentStep = useSelector((state) => state.engagement.currentStep);
  const targets = useSelector((state) => state.forecast.targets);
  const targetsDataLoading = useSelector(
    (state) => state.forecast.targetsDataLoading
  );
  const user = useSelector((state) => state.user.user);
  const [addTargetTableData, setTargetTable] = useState([]);
  const [isDataSaveInProgress, setIsDataSaveInProgress] = useState(false);
  const [tableDataValidationError, setTableDataValidationError] = useState("");
  const [applyError, setApplyError] = useState(false);
  const [lockedData, setLock] = useState();
  const [lockedBy, setLockedby] = useState();
  const isTargetDeleted = useSelector((state) => state.forecast.targetDeleted);
  function handleCancelClick() {
    navigate(`/${routes.createNewEngagement}`, {
      state: {
        engagementId: engagement.id,
        regionId: selectedRegion.id,
      },
      gestureEnabled: false,
    });
  }

  async function applyChanges() {
    setIsDataSaveInProgress(true);
    // Bhushan: Removed the commented code for fetching engagement data
    /* 
      const request = {
        id: engagement.id,
      };
      const response = await getEngagement({ request });
      if (response.data.forecast_inprogress === 0) {
    */
    if (engagement?.forecast_inprogress === 0) {
      setIsDataSaveInProgress(false);
      setApplyError(true);
    } else {
      setApplyError(false);
      try {
        // await uploadFileToBlob({
        //   file: trigger,
        //   moduleName: "m2target",
        //   fileName: `TriggerTarget_${engagement.engagementCode}_${
        //     user.username
        //   }_${formarDateTime(new Date(), "ddMMyyyy HH:mm:ss")}.txt`,
        // });
        let request = {
          ModuleName: "m2target",
          FileName: `TriggerTarget_${engagement.engagementCode}_${
            user.username
          }_${formarDateTime(new Date(), "ddMMyyyy HH:mm:ss")}.txt`,
        };
        await uploadTextFile({ request });

        await applyTarget({ request: { engagementId: engagement.id } });

        if (engagement.skip_ForeCast === 1) {
          dispatch(setSkipForecast({ skipForecast: 0 }));
          await updateSkipForecast({
            request: {
              engagementId: engagement.id,
              skipvalue: 0,
            },
          });
        }
      } catch (error) {
        console.error(
          "Error updating batch id for target specification",
          error
        );
      }
      setIsDataSaveInProgress(false);

      navigate(`/${routes.createNewEngagement}`, {
        state: {
          engagementId: engagement.id,
          regionId: selectedRegion.id,
        },
        gestureEnabled: false,
      });
    }
  }

  function onAddTargetClick() {
    dispatch(setWafErrorFlag(false));
    navigate(`${routes.addTargetSpecification}`, {
      state: { engagementId: engagement.id },
      gestureEnabled: false,
    });
  }
  // Function to check is the target is valid or not
  const checkIsvalidated = (isValidated, flag) => {
    if (isValidated === "N") {
      return "N";
    } else return flag;
  };
  // Functiton to for the targets to show in the table
  async function getAllRecordsBySpecification() {
    let uniqueBatchGroupIDs = [
      ...new Set(targets.map((element) => element.batchGroupID)),
    ];
    let rowData = [];
    let scopeArray = [];
    uniqueBatchGroupIDs.forEach((value) => {
      let emissionArray = [];
      let geoArray = [];
      let custArray = [];
      let orgArray = [];
      let uniqueRow = [];
      let name = "";
      let description = "";
      let scope = "";
      let targetType = "";
      let temporalType = "";
      let percentageValue = "";
      let baseYear = 0;
      let targetYear = 0;
      let batchGroupId = 0;
      let statusFlag = "";
      let id = 0;
      let activeFlag = "";
      let isValidated = "";
      targets.forEach((element) => {
        scopeArray.push(element.scope);
        if (element.batchGroupID === value) {
          name = element.name;
          description = element.description;
          scope = element.scope;
          targetType = element.target_type;
          temporalType = element.temporal_type;
          percentageValue = element.target_percentage;
          baseYear = element.baseYear;
          targetYear = element.target_year;
          batchGroupId = element.batchGroupID;
          statusFlag = element.statusFlag;
          id = element.id;
          activeFlag = element.activeFlag;
          isValidated = checkIsvalidated(isValidated, element.isValidated);
          let emissionSpec = element.category_level1
            ? element.category_level1 +
              (element.category_level2
                ? "-" +
                  element.category_level2 +
                  (element.category_level3 ? "-" + element.category_level3 : "")
                : element.category_level3
                ? "-" + element.category_level3
                : "")
            : "-";
          emissionArray.push(
            emissionSpec === "-"
              ? emissionSpec
              : scope + "-" + emissionSpec + ",emission"
          );

          geoArray.push(
            element.region_level1 +
              "-" +
              element.region_level2 +
              "-" +
              element.region_level3 +
              ",geo"
          );

          orgArray.push(
            element.entity_level1 +
              "-" +
              element.entity_level2 +
              "-" +
              element.entity_level3 +
              "-" +
              element.entity_asset +
              ",org"
          );
          let customSpec = element.custom_specification1
            ? element.custom_specification1 +
              (element.custom_specification2
                ? "-" +
                  element.custom_specification2 +
                  (element.custom_specification3
                    ? "-" + element.custom_specification3
                    : "")
                : element.custom_specification3
                ? "-" + element.custom_specification3
                : "")
            : "-";
          custArray.push(customSpec + ",custom");
        }
      });
      uniqueRow = [
        ...new Set(emissionArray),
        ...new Set(geoArray),
        ...new Set(orgArray),
        ...new Set(custArray),
      ];
      uniqueRow.push({
        name: name,
        description: description,
        scope: scope,
        targetType: targetType,
        temporalType: temporalType,
        percentageValue: percentageValue,
        baseYear: baseYear,
        targetYear: targetYear,
        batchGroupId: batchGroupId,
        statusFlag: statusFlag,
        id: id,
        activeFlag: activeFlag,
        isValidated: isValidated,
      });
      rowData.push(uniqueRow);
    });
    let rows = rowData.map((element) => {
      let emissionspec = [];
      let geospec = [];
      let orgspec = [];
      let customspec = [];
      for (let i = 0; i < element.length - 1; i++) {
        let record = element[i].split(",emission");
        if (element[i].includes(",emission")) {
          emissionspec.push(record[0]);
        }
      }
      for (let i = 0; i < element.length - 1; i++) {
        let record = element[i].split(",geo");
        if (element[i].includes(",geo")) {
          geospec.push(record[0]);
        }
      }
      for (let i = 0; i < element.length - 1; i++) {
        let record = element[i].split(",org");
        if (element[i].includes(",org")) {
          orgspec.push(record[0]);
        }
      }
      for (let i = 0; i < element.length - 1; i++) {
        let record = element[i].split(",custom");
        if (element[i].includes(",custom")) {
          customspec.push(record[0]);
        }
      }
      return {
        targetName: element[element.length - 1].name,
        targetDescription: element[element.length - 1].description,
        targetType: element[element.length - 1].targetType,
        percentageValue: element[element.length - 1].percentageValue + "%",
        baseYear: element[element.length - 1].baseYear,
        targetYear: element[element.length - 1].targetYear,
        temporalType: element[element.length - 1].temporalType,
        emissionSpec: emissionspec,
        geoSpec: geospec,
        orgSpec: orgspec,
        customSpec: customspec,
        fullRow: element,
        batchGroupId: element[element.length - 1].batchGroupId,
        statusFlag: element[element.length - 1].statusFlag,
        activeFlag: element[element.length - 1].activeFlag,
        isValidated: element[element.length - 1].isValidated,
      };
    });
    setTargetTable(rows);
  }

  async function onDelete() {
    const request = {
      engagementId: engagement.id,
    };
    dispatch(getTargets(request));
  }

  useEffect(() => {
    if (engagement?.id) {
      const request = {
        engagementId: engagement.id,
      };

      dispatch(getTargets(request));
      dispatch(setselectedUIAllFilters({selectedUIAllFilters: {}}));
      dispatch(setHierarchialData({ hierarchialData: [] }));
      dispatch(
        setSelectedAllLevels({ selectedAllLevels: {
            emissionLevel: '',
            orgLevel: '',
            geoLevel: '',
            cusLevel: ''
          } 
        })
      );
    }
  }, [engagement?.id, dispatch]);

  useEffect(() => {
    if (engagement?.id) {
      getAllRecordsBySpecification();
    }
  }, [dispatch, engagement?.id, targets]);

    useEffect(() => {
      const request = {
        LockedBy: user.username,
        ModuleName: "Engagement",
        EngagementID: engagement.id,
      };

       dispatch(getLockingData(request))
        .then((action) => {
          if (action) {
            const lockedData = action.payload.data.lockStatus;
            const lockedBy = action.payload.data.lockedBy;
            setLock(lockedData);
            setLockedby(lockedBy);
          } else {
            console.error("Failed to fetch locking data:", action.error);
          }
        })
        .catch((error) => {
          console.error("Error fetching locking data:", error);
        });
    }, [dispatch, user?.username, engagement.id]);

  return (
    <div className="add-target">
      <div className="add-target-eng-header">
        <div className="add-target-eng-header-title">
          {steps[currentStep]?.stepHeading}
        </div>
        <div className="add-target-eng-header-stepper">
          <Stepper
            steps={steps}
            currentStep={currentStep}
            stepIndex={stepIndex}
          />
        </div>
      </div>
      <div className="add-target-content">
        <div className="add-forecast-body">
          <div className="add-forecast-body-upload-year">
            <span className="add-forecast-body-upload-year-label">
              {foreStartYear}
            </span>
            <span className="add-forecast-body-upload-year-label-l">
              {engagement.mostRecentYear}
            </span>
            <span className="add-forecast-body-upload-year-label">
              {foreEndYear}
            </span>
            <span className="add-forecast-body-upload-year-label-l">
              {engagement.foreCastEndYear}
            </span>
          </div>
          <div className="add-target-content-header">
            <span className="add-target-header-main">{addTarget}</span>
            <div className="add-target-header-button">
              <Button
                variant="primary-alt"
                onClick={onAddTargetClick}
                disabled={
                  isDataSaveInProgress ||
                  (lockedData === 1 && lockedBy !== user.username)
                }
                tooltip={addtargetTooltip}
              >
                <AddIcon />
                {AddTargetBtn}
              </Button>
            </div>
          </div>
          <div className="add-target-body-table">
            <Table
              rowData={addTargetTableData.filter(
                (element) => element.activeFlag === "A"
              )}
              colDefs={[
                {
                  field: "actions",
                  headerName: "",
                  flex: 1,
                  width: 150,
                  suppressMovable: true,
                  pinned: "left",
                  cellRenderer: CustomEditComponent,
                  cellRendererParams: () => {
                    return {
                      onDelete: onDelete,
                      isLocked: lockedData === 1 && lockedBy !== user.username,
                    };
                  },
                },
                {
                  field: "targetName",
                  filter: true,
                  headerName: addTargetTableHeaderTargetName,
                  headerTooltip: addTargetTableHeaderTargetName,
                  flex: 1,
                  minWidth: 200,
                  suppressMovable: true,
                  pinned: "left",
                  className: "name",
                },
                {
                  field: "targetDescription",
                  filter: true,
                  headerName: addTargetTableHeaderTargetDesc,
                  headerTooltip: addTargetTableHeaderTargetDesc,
                  flex: 1,
                  minWidth: 200,
                  suppressMovable: true,
                },
                {
                  field: "emissionSpec",
                  filter: true,
                  headerName: emission,
                  headerTooltip: emission,
                  cellRenderer: CustomChipscomponent,
                  cellRendererParams: () => {
                    return {
                      spec: "emission",
                    };
                  },
                  minWidth: 400,
                  flex: 1,
                  suppressMovable: true,
                },
                {
                  field: "geoSpec",
                  filter: true,
                  headerName: addTargetTableHeaderGeo,
                  headerTooltip: addTargetTableHeaderGeo,
                  cellRenderer: CustomChipscomponent,
                  cellRendererParams: () => {
                    return {
                      spec: "geo",
                    };
                  },
                  minWidth: 400,
                  flex: 1,
                  suppressMovable: true,
                },
                {
                  field: "orgSpec",
                  filter: true,
                  headerName: addTargetTableHeaderOrg,
                  headerTooltip: addTargetTableHeaderOrg,
                  cellRenderer: CustomChipscomponent,
                  cellRendererParams: () => {
                    return {
                      spec: "org",
                    };
                  },
                  minWidth: 400,
                  flex: 1,
                  suppressMovable: true,
                },
                {
                  field: "customSpec",
                  filter: true,
                  headerName: addTargetTableHeaderCustom,
                  headerTooltip: addTargetTableHeaderCustom,
                  cellRenderer: CustomChipscomponent,
                  cellRendererParams: () => {
                    return {
                      spec: "custom",
                    };
                  },
                  minWidth: 400,
                  flex: 1,
                  suppressMovable: true,
                },
                {
                  field: "targetType",
                  filter: true,
                  headerName: addTargetTableHeaderTargetType,
                  headerTooltip: addTargetTableHeaderTargetType,
                  minWidth: 300,
                  flex: 1,
                  suppressMovable: true,
                },
                {
                  field: "temporalType",
                  filter: true,
                  headerName: addTargetTableHeaderTemporalType,
                  headerTooltip: addTargetTableHeaderTemporalType,
                  flex: 1,
                  minWidth: 200,
                  suppressMovable: true,
                },
                {
                  field: "percentageValue",
                  filter: true,
                  headerName: addTargetTableHeaderDataPercentageValue,
                  headerTooltip: addTargetTableHeaderDataPercentageValue,
                  flex: 1,
                  minWidth: 200,
                  suppressMovable: true,
                },
                {
                  field: "baseYear",
                  filter: true,
                  headerName: addTargetTableHeaderDataBaseYear,
                  headerTooltip: addTargetTableHeaderDataBaseYear,
                  flex: 1,
                  minWidth: 200,
                  suppressMovable: true,
                },
                {
                  field: "targetYear",
                  filter: true,
                  headerName: addTargetTableHeaderDataTargetYear,
                  headerTooltip: addTargetTableHeaderDataTargetYear,
                  flex: 1,
                  minWidth: 200,
                  suppressMovable: true,
                },
              ]}
              rowClassRules={{
                "add-target-table-pending-validation": (params) => {
                  return params.data.isValidated === "N";
                },
              }}
              draggable={false}
              loading={targetsDataLoading}
            />
            {tableDataValidationError ? (
              <MotifErrorMessage className="decarb-input-error-message">
                {tableDataValidationError}
              </MotifErrorMessage>
            ) : (
              <div className="decarb-input-hide-error">No Error</div>
            )}
          </div>
        </div>
      </div>
      <div className="add-target-footer">
        <Button
          variant="secondary"
          onClick={handleCancelClick}
          disabled={isDataSaveInProgress}
        >
          {CancelBtn}
        </Button>
        <div className="add-target-footer-nav-buttons">
          <LoadingIndicatorEmbed show={isDataSaveInProgress}>
            <Button
              variant="primary"
              onClick={applyChanges}
              disabled={
                isDataSaveInProgress ||
                addTargetTableData.filter(
                  (element) => element.isValidated === "N"
                ).length > 0 ||
                (lockedData === 1 && lockedBy !== user.username) ||
                (addTargetTableData.length === 0 && !isTargetDeleted)
              }
            >
              {ApplyBtn}
            </Button>
          </LoadingIndicatorEmbed>
          {applyError ? (
            <MotifErrorMessage>{applyErrorMessageTarget}</MotifErrorMessage>
          ) : (
            ""
          )}
        </div>
      </div>
    </div>
  );
}